import type { APIErrorType } from '@core/types';

export interface ErrorDetail {
  message: string;
  name: string;
  statusCode?: number;
  toString: () => string;
}

/**
 * Takes as an argument either a generic error or an API error and returns a
 * normalized object with details about the error.
 */
export function getErrorDetail<E extends APIErrorType | Error>(error: E): ErrorDetail {
  // by default pull basic details from the error
  let name = error.name;
  let message = error.message;
  let statusCode: number | undefined;

  // but if this is an API error, we can return more detailed information
  if ('status' in error) {
    statusCode = error.status;
    name = error.statusText || error.name;
    message =
      error.info?.errors.map(err => (err.message.endsWith('.') ? err.message : `${err.message}.`)).join(' ') ||
      error.info?.detail ||
      error.message;
  }

  return {
    name,
    message,
    statusCode,
    toString: () => `Error detail:
  - Name: ${name}
  - Message: ${message}
  - Status code: ${statusCode ?? 'N/A'}`,
  };
}
